import { baseApi } from "./api"

const importExportApi = baseApi.enhanceEndpoints({ addTagTypes: ['PlotsExport'] }).injectEndpoints({
    endpoints: (builder) => ({
        importPlots: builder.mutation({
            query(arr) {
                return {
                    url: `plot/import/`,
                    method: 'POST',
                    body: {
                        plots: arr,
                    },
                }
            },
            // Invalidates all Plot-type queries providing the `LIST` id
            invalidatesTags: [{ type: 'Plots', id: 'LIST' }, { type: 'PlotsExport', id: 'LIST' }],
        }),
        exportPlots: builder.mutation({
            query() {
                return {
                    url: `plot/export/`,
                    method: 'GET',
                }
            },
            providesTags: (result) =>
                // is result available?
                result
                    ? // successful query
                    [
                        ...result.map(({ _id }) => ({ type: 'PlotsExport', id: _id })),
                        { type: 'PlotsExport', id: 'LIST' },
                    ]
                    : // an error occurred, but we still want to refetch this query when `{ type: 'PlotsExport', id: 'LIST' }` is invalidated
                    [{ type: 'PlotsExport', id: 'LIST' }],
        }),
        cleanPlots: builder.mutation({
            query() {
                return {
                    url: `plot/import/clean`,
                    method: 'POST',
                }
            },
            invalidatesTags: [{ type: 'Plots', id: 'LIST' }, { type: 'PlotsExport', id: 'LIST' }],
        }),
    }),
})

export const {
    useImportPlotsMutation,
    useExportPlotsMutation,
    useCleanPlotsMutation,
} = importExportApi